import React from 'react';
import { useSelector } from 'react-redux';
import { MemoryRouter } from 'react-router';
import URL from 'url-parse';

import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import type { Modal } from '@swf/core/models/modal';
import { select } from '@swf/core/store';
import type { StaticContext } from '@swf/core/types/StaticContext';
import { SignupWizard } from '@swf/first';

import ModalRoute from './ModalRoute';

const SignupRoute: React.FC<{ staticContext: StaticContext }> = ({ staticContext = {} }) => {
  const SWCSignup = useFeature(FeatureFlag.SwcSignup);
  const bankID = useFeature(FeatureFlag.BankID);
  const signupPath = `/auth/registration${bankID ? '/bankid' : ''}`;
  const origin = useSelector(select.location.getOrigin);
  const { path, locationState } = (useSelector(select.modal.getCurrent) || {}) as Partial<Modal>;
  const { redirectTo = '/' } = useSelector(select.localSettings.get);

  staticContext.prefetch = async ({ dispatch }, version) => {
    const url = new URL(origin);
    url.set('pathname', redirectTo);
    await dispatch.page.fetch({ href: url.href, version });
  };

  return SWCSignup ? (
    <MemoryRouter
      keyLength={process.env.NODE_ENV === 'test' ? 0 : 6}
      initialEntries={[{ pathname: path, state: locationState }]}
    >
      {React.createElement(SignupWizard)}
    </MemoryRouter>
  ) : (
    <ModalRoute modal={{ path: signupPath }} />
  );
};

export default SignupRoute;
